interface StatusStyle {
  bg: string;
  text: string;
  label: string;
}

const REPORT_STATUS_STYLES: Record<string, StatusStyle> = {
  assigned: {
    bg: "bg-status-assigned-bg",
    text: "text-status-assigned-text",
    label: "Assigned",
  },
  in_review: {
    bg: "bg-status-in-review-bg",
    text: "text-status-in-review-text",
    label: "In Review",
  },
  drafted: {
    bg: "bg-status-in-review-bg",
    text: "text-status-in-review-text",
    label: "Draft",
  },
  published: {
    bg: "bg-status-published-bg",
    text: "text-status-published-text",
    label: "Published",
  },
};

const HORMONE_STATUS_STYLES: Record<string, { bg: string; text: string }> = {
  normal: {
    bg: "bg-status-normal-bg",
    text: "text-status-normal-text",
  },
  high: {
    bg: "bg-status-high-bg",
    text: "text-status-high-text",
  },
  low: {
    bg: "bg-status-low-bg",
    text: "text-status-low-text",
  },
};

const FALLBACK_STYLE = { bg: "bg-bg-tertiary", text: "text-text-secondary" };

export function ReportStatusBadge({ status }: { status: string }) {
  const style = REPORT_STATUS_STYLES[status] ?? {
    ...FALLBACK_STYLE,
    label: status,
  };
  return (
    <span
      className={`inline-block px-2 py-0.5 rounded-lg text-xs font-medium ${style.bg} ${style.text}`}
    >
      {style.label}
    </span>
  );
}

export function HormoneStatusBadge({ status }: { status: string }) {
  const style = HORMONE_STATUS_STYLES[status] ?? FALLBACK_STYLE;
  return (
    <span
      className={`inline-block px-2 py-0.5 rounded-lg text-xs font-semibold capitalize ${style.bg} ${style.text}`}
    >
      {status}
    </span>
  );
}
